import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
const rows: {
  before: string;
  after: string;
}[] = [{
  before: 'Pasas un presupuesto con pánico y rezas para que no te digan que estás loca',
  after: 'Presentas tu precio con argumentos y lo sostienes sin negociar'
}, {
  before: 'Te piden precio de amiga y dices que sí',
  after: 'Tienes la respuesta escrita, y la usas sin sentir culpa'
}, {
  before: 'Mandas el presupuesto y empieza el silencio',
  after: 'Una secuencia que te da respuesta clara en días, no en semanas'
}, {
  before: 'Cierras todo de palabra y duermes mal',
  after: 'Proceso, anticipos y condiciones claras desde el primer mensaje'
}, {
  before: 'Pagas cuota a un portal para pelear por precio',
  after: 'Captas tus propias novias y las llevas directo a tu WhatsApp'
}, {
  before: 'Tu familia cree que esto es un hobby',
  after: 'Tú sabes que es un negocio — y tus números lo demuestran'
}];
export function Transformation() {
  return <section className="w-full bg-white py-16 sm:py-24" data-id="element-261" data-mp="1c6tc8r94nl7k">
      <div className="mx-auto max-w-5xl px-5" data-id="element-262" data-mp="17770yncv0f1e">
        <h2 className="mx-auto max-w-3xl text-center font-serif text-3xl leading-snug sm:text-[2.7rem] sm:leading-tight text-ink" data-id="element-263" data-mp="175dsr3mllmra">
          De &ldquo;la que ayuda con las bodas&rdquo; a la que dirige el negocio
        </h2>
        <div className="rule-gold mx-auto mt-8 w-32" aria-hidden="true" data-id="element-264" data-mp="y8br91alwmtc" />

        <div className="mt-12 overflow-hidden border border-gold-soft" data-id="element-265" data-mp="1uw01yy8c9d2v">
          <div className="grid grid-cols-1 sm:grid-cols-2" data-id="element-266" data-mp="1quoaen5wmhs1">
            <div className="border-b border-gold-soft bg-blush-soft px-6 py-4 text-[11px] uppercase tracking-[0.2em] text-blush-deep sm:border-r" data-id="element-267" data-mp="1m47u8vap8i1z">
              Antes del sistema
            </div>
            <div className="hidden border-b border-gold-soft bg-gold-tint px-6 py-4 text-[11px] uppercase tracking-[0.2em] text-gold-dark sm:block" data-id="element-268" data-mp="1h3aaiea1jfyd">
              Con el Wedding Pro OS
            </div>
          </div>

          {rows.map((row, index) => <div key={row.after} className={`grid grid-cols-1 sm:grid-cols-2 ${index > 0 ? 'border-t border-gold-soft/70' : ''}`} data-id="element-269" data-mp="2src5qdn5l58n" data-mpi={index}>
              <p className="flex items-start gap-3 bg-ivory px-6 py-5 text-[15px] text-ink-soft sm:border-r sm:border-gold-soft/70" data-id="element-270" data-mp="2jx7fnwfufxu6">
                <XIcon className="mt-1 h-4 w-4 shrink-0 text-blush-deep" aria-hidden="true" data-id="element-271" data-mp="2nwy6g05dedyp" />
                {row.before}
              </p>
              <p className="flex items-start gap-3 bg-white px-6 py-5 text-[15px] font-medium text-ink" data-id="element-272" data-mp="2ew9owvgrpvh2">
                <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-273" data-mp="2117im780e43q" />
                {row.after}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}